import { Box, styled } from '@mui/material';

export const ResponsiveRowContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  gap: theme.spacing(2),

  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
  },
}));
